export default __webpack_public_path__ + "static/media/WNo.7-7.0d77d922.jpg";